import { Separator } from '@/components/ui/separator';

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const links = [
    { label: 'About', href: '#about' },
    { label: 'Capabilities', href: '#capabilities' },
    { label: 'Who We Serve', href: '#who-we-serve' },
    { label: 'Why Us', href: '#why-us' },
    { label: 'Teaming', href: '#teaming' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <img
              src="/logo-transparent.png"
              alt="Cole Utilities"
              className="h-12 w-auto mb-3"
            />
            <p className="font-body text-sm text-[#737373] mt-3 leading-relaxed max-w-xs">
              The execution platform that plays every position — so your mission
              never slows down.
            </p>
          </div>

          <div>
            <p className="font-body text-xs text-[#B8102E] uppercase tracking-[0.2em] mb-4">
              Quick Links
            </p>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="font-body text-sm text-[#A3A3A3] hover:text-[#B8102E] transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-body text-xs text-[#B8102E] uppercase tracking-[0.2em] mb-4">
              Connect
            </p>
            <p className="font-body text-sm text-[#A3A3A3] mb-2">
              info@coleutilities.com
            </p>
            <p className="font-body text-sm text-[#A3A3A3] mb-2">
              470-342-2327
            </p>
            <p className="font-body text-sm text-[#A3A3A3]">
              Atlanta, GA
            </p>
          </div>
        </div>

        <Separator className="bg-[#2A2A2A] my-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#737373]">
            &copy; {new Date().getFullYear()} Cole Utilities. All rights reserved.
          </p>
          <p className="font-body text-xs text-[#737373]">
            A Cole Holdings Company
          </p>
        </div>
      </div>
    </footer>
  );
}
